import {createSlice} from '@reduxjs/toolkit'
import {ROUTE_PATH} from '../../app/constants'

const applicationReview = () => ({
    header : "Application review",
    navigation : {
        next : ROUTE_PATH.CONFIRM_BEFORE_PAYMENT //ROUTE_PATH.ADDITIONAL_COLLECTOR_QUESTION
    },
    navigationRenewal : {
        next : ROUTE_PATH.CONFIRM_BEFORE_PAYMENT //ROUTE_PATH.COLLECTORS_REVIEW
    }
})

const applicationReviewSlice = createSlice({
    name : "applicationReview",
    initialState : applicationReview(),
    reducers : {} 
})

export default applicationReviewSlice.reducer